
export class Template {
	public templateID: string;
	public templateName: string;
	public templateJSON: string;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}